import moment from 'moment';
import { buildUrl } from 'helpers/misc';
import { SUPPLIES } from 'constants/apis';
import Fetch from 'helpers/fetch';
import { isIE } from './detectEdgeIE';
import isIOS from './isIos';

const IEY2KHelper = (inputDate) => {
  let date = inputDate;

  // Please fix this in 2050
  if (isIE()) {
    if (typeof date === 'string') {
      date = date.replace('-', '/');
    }
    date = new Date(date);
    if (date.getFullYear() < 2000) {
      date = new Date(
        date.getFullYear() + 100, date.getUTCMonth(),
        date.getUTCDate(), date.getHours(), date.getMinutes(), date.getSeconds(),
      );
    } else {
      date = new Date(
        date.getFullYear(), date.getUTCMonth(),
        date.getUTCDate(), date.getHours(), date.getMinutes(), date.getSeconds(),
      );
    }
  }

  return date;
};

const isNumber = value => !Number.isNaN(parseFloat(value));
const formatDate = (value) => {
  if (!isNumber(Date.parse(value))) {
    return '';
  }

  if (moment.isMoment(value)) {
    return moment(value).format('YYYY-MM-DD');
  }

  let date = value;

  if (!date.getMonth && !isIE() && !isIOS()) {
    date = new Date(`${date} 00:00`);
  }

  return moment(IEY2KHelper(date)).format('YYYY-MM-DD');
};

const isValidDate = date => moment(date).isValid();

const isImminent = (datetime, imminentGapHours = 24) => {
  const now = moment(new Date());
  const newDate = moment(IEY2KHelper(datetime));
  const diff = newDate.diff(now, 'h');

  return diff < imminentGapHours;
};

const isDateConflicting = (datetime, compareDateTime, hours = 24) => {
  const date1 = moment(datetime);
  const date2 = moment(compareDateTime);
  const diff = date2.diff(date1, 'h');

  return (diff < hours) && (diff > -(hours));
};

const isPastDate = (date, time = '0:00') => {
  const now = moment(new Date());
  const newDate = moment(IEY2KHelper(`${moment(formatDate(date)).format('YYYY/MM/DD')} ${time}`));
  const diff = moment.duration(newDate.diff(now)).asHours();

  return diff < 0;
};

const isWeekday = datetime => moment(IEY2KHelper(datetime)).day() % 6 !== 0;

const format = (date, f) => moment(IEY2KHelper(date)).format(f.replace('yyyy', 'YYYY'));

const fetchIsHoliday = (requiredByDate, maxxamDestinationID) => {
  const params = {
    maxxamDestinationID,
    requiredByDate,
  };

  return Fetch.Get(buildUrl(`${SUPPLIES}/OrderCheckIsHoliday`, params))
    .then(data => data.json())
    .then((data) => { //eslint-disable-line
      return data;
    });
};

const makeLabelDate = (year, month, day) => {
  const formatedValue = [year, month, day].filter(x => x).join('-');

  return formatedValue.split('-').filter(item => item !== '').map(x => x.padStart(2, '0')).join('-');
};

const addWeekdays = (inputDate, numberOfDays) => {
  let date = moment(inputDate);
  let days = numberOfDays;
  while (days > 0) {
    date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
      days -= 1;
    }
  }
  return date.format('YYYY-MM-DD');
};

export default formatDate;
export {
  isValidDate,
  isImminent,
  isPastDate,
  isWeekday,
  format,
  moment,
  fetchIsHoliday,
  makeLabelDate,
  isDateConflicting,
  addWeekdays,
  IEY2KHelper,
};



// WEBPACK FOOTER //
// ./src/helpers/date.js